<div class="bkg">
    <div class="header">חלק ממי שכבר שיחקנו איתם:</div>

    <div class="ligh-box">
        <div class="row">
            <div *ngFor="let imgSrc of lstImages" class="img-wrap">
                <img data-aos="fade-up"
                class="img" [src]="baseURL+imgSrc">
            </div>

        </div>
    </div>

</div>